import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Table } from "antd";
import NumberFormat from "react-number-format";
import _ from "i18n";

import { fetchCollaboratorFinancial } from "Thunks";
import { setCapacityPlaningCollaboratorDate } from "Actions";
import { getTimeByDurationFormat } from "Utils";

import NotFoundV2 from "../NotFound/NotFoundV2";
import CapacityPlanningCollaboratorFilter from "./CapacityPlanningCollaboratorFilter";

import styles from "./CapacityPlaning.local.scss";
import moment from "moment";

class CapacityPlaningCollaboratorFinancials extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);

    this.state = {
      filterFinancialFormIsVisible: false,
      filterFormIsVisible: false,
      loading: false,
      yearDivIsVisible: false,
      selectedYear: new Date().getFullYear().toString()
    };
  }

  componentDidMount() {
    const { date } = this.props;
    this.fetchCapacityPlaningCollaborator();
    this.setState({
      selectedYear: date
        ? date.format("Y")
        : new Date().getFullYear().toString()
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { date } = this.props;
    if (prevProps.date !== date) {
      this.setState({
        selectedYear: date
          ? date.format("Y")
          : new Date().getFullYear().toString()
      });
      this.fetchCapacityPlaningCollaborator();
    }
  }

  // //******************   Content Functions END  **************//

  //******************   Content Render functions  ****************//
  handleYearChange = year => {
    const { dispatch } = this.props;
    dispatch(setCapacityPlaningCollaboratorDate(this.props.date));
    this.fetchCapacityPlaningCollaborator();
    this.props.onAnalyseDateChange &&
      this.props.onAnalyseDateChange(null, year);
    this.setState({ yearDivIsVisible: false, selectedYear: year.toString() });
  };

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  renderYearSelect = () => {
    const { yearDivIsVisible, selectedYear } = this.state;
    const { arrivalDate } = this.props;
    let years = [
      moment().year() - 2,
      moment().year() - 1,
      moment().year()
    ].filter(year => (arrivalDate ? year >= arrivalDate.year() : true));

    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{
          color: "#f1f2f4",
          background: "#6D7F92",
          width: "2%",
          zIndex: "3",
          minWidth: "9%"
        }}
      >
        <div className={styles.customed_select_header}>
          <span>{selectedYear}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  style={{ color: "#ffffff" }}
                  className={"icon icon-arrow-down"}
                />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((year, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleYearChange(year)}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderCollaboratorFinancialTdComponent = (item, value, record) => {
    if (value == null) {
      return (
        <span className={"balance-sheet-td-component"}>
          <span className={"balance-sheet-td-value"} />
        </span>
      );
    }
    if (item === "budget" || item === "collabReal") {
      return (
        <span
          style={{
            backgroundColor:
              record.client === "TOTAL" ? "rgb(200, 205, 210)" : ""
          }}
          className={classnames(
            "balance-sheet-td-component",
            "capacity-planning-table"
          )}
        >
          <span
            style={{ fontSize: "13px" }}
            className={classnames("balance-sheet-td-value")}
          >
            {getTimeByDurationFormat(value)}
          </span>
        </span>
      );
    } else if (item === "caAdjusted") {
      return (
        <span
          style={{
            padding: 0,
            backgroundColor:
              record.client === "TOTAL" ? "rgb(200, 205, 210)" : "#f1f2f4"
          }}
          className={classnames(
            "balance-sheet-td-component",
            "capacity-planning-total"
          )}
        >
          <span>
            <span>
              {" "}
              €{" "}
              <NumberFormat
                value={parseFloat(parseFloat(value).toFixed(2))}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                suffix={""}
              />
            </span>
            <div
              className={`row medium-12 ${styles.collaborator_rate}`}
              style={{ marginLeft: "-2%" }}
            >
              <div className="medium-6">
                <span>
                  {_("effectiveRate") + ": "}
                  {record.tauxEffectif || record.tauxEffectif === 0 ? (
                    <NumberFormat
                      value={record.tauxEffectif}
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      suffix={" €/heure "}
                    />
                  ) : (
                    "0 €/heure "
                  )}{" "}
                </span>
              </div>
              <div className="medium-6">
                <span>
                  {_("budgetaryRate") + ": "}
                  {record.tauxBudgetaire || record.tauxBudgetaire === 0 ? (
                    <NumberFormat
                      value={record.tauxBudgetaire}
                      displayType={"text"}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      suffix={" €/heure "}
                    />
                  ) : (
                    "0 €/heure "
                  )}
                </span>
              </div>
            </div>
          </span>
        </span>
      );
    } else {
      return (
        <span
          style={{
            padding: 0,
            backgroundColor:
              record.client === "TOTAL" ? "rgb(200, 205, 210)" : "#f1f2f4"
          }}
          className={classnames(
            "balance-sheet-td-component",
            "capacity-planning-total"
          )}
        >
          <span
            style={{ fontSize: "13px" }}
            className={classnames("balance-sheet-td-value")}
          >
            <span>{value}</span>
            <div style={{ marginTop: "-11px" }}>
              <span>
                {item === "benchmarkEffectif"
                  ? this.renderRatingStars(
                      record.collaborator_id,
                      record.rateEffectif
                    )
                  : item === "benchmarkBudgetaire"
                    ? this.renderRatingStars(
                        record.collaborator_id,
                        record.rateBudgetaire
                      )
                    : ""}
              </span>
            </div>
          </span>
        </span>
      );
    }
  };

  renderRatingStars(id, value) {
    let stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(i === 0 ? i < value : i <= value);
    }
    return stars.map((s, k) => (
      <img
        key={id + k}
        alt={""}
        src={
          s
            ? value > 6.5
              ? "/img/icons/gold_star.svg"
              : "/img/icons/star.svg"
            : "/img/icons/light_star.svg"
        }
      />
    ));
  }

  renderCollaboratorFinancial = () => {
    const {
      collaboratorFinancialData,
      collaboratorFinancialColumns
    } = this.props;

    let columns = [];
    if (
      collaboratorFinancialData.data !== undefined &&
      collaboratorFinancialData.data.length
    ) {
      columns = [
        {
          title: "client",
          width: 200,
          dataIndex: "client",
          key: "client",
          render: (text, record) => (
            <span
              className={classnames("balance-sheet-td-component")}
              style={{
                backgroundColor:
                  record.client === "TOTAL" ? "rgb(200, 205, 210)" : ""
              }}
            >
              <span className={"balance-sheet-key-indicator"}>
                <span className={text && text.length >= 34 ? "label-wrap" : ""}>
                  <div
                    style={{
                      textAlign: "left",
                      fontSize: "12px"
                    }}
                    className={classnames("balance-sheet-td-value")}
                  >
                    {text}
                  </div>
                </span>
              </span>
            </span>
          )
        }
      ];
    }
    collaboratorFinancialColumns.forEach((item, i) => {
      columns.push({
        title:
          item === "benchmarkEffectif"
            ? _("benchmarkEffectif")
            : item === "benchmarkBudgetaire"
              ? _("benchmarkBudgetaire")
              : item === "budget"
                ? _("budgetH")
                : item === "collabReal"
                  ? _("PrestaTs")
                  : _(item),
        width:
          item === "budget" || item === "collabReal"
            ? 100
            : item === "caAdjusted"
              ? 260
              : 220,
        dataIndex: item,
        key: item,
        render: (text, record) =>
          this.renderCollaboratorFinancialTdComponent(item, text, record)
      });
    });

    return collaboratorFinancialData.data !== undefined &&
      collaboratorFinancialData.data.length === 0 ? (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        text={_("no data found")}
        buttonIgnored={true}
      />
    ) : (
      <div>
        <div>
          <Table
            columns={columns}
            dataSource={collaboratorFinancialData.data}
            scroll={{ x: 1150 }}
            rowKey="key"
            pagination={false}
          />
        </div>
      </div>
    );
  };

  setYearsWrapperRef(node) {
    this.wrapperYearRef = node;
  }

  handleFinancialFilterFormIsVisible = isVisible => {
    this.setState({ filterFinancialFormIsVisible: isVisible });
  };

  fetchCapacityPlaningCollaborator = () => {
    const { dispatch, date } = this.props;
    dispatch(fetchCollaboratorFinancial(date));
  };

  render() {
    const { fetching, date, collaboratorFinancialData } = this.props;
    return (
      <div>
        <div className="row align-center medium-12">
          <div className="medium-12">
            <CapacityPlanningCollaboratorFilter
              filterFormIsVisible={this.handleFinancialFilterFormIsVisible}
              customAddOn={this.renderYearSelect()}
              analyseDate={date}
              resultCount={
                collaboratorFinancialData.data &&
                collaboratorFinancialData.data.length > 0
                  ? collaboratorFinancialData.data.length - 1
                  : 0
              }
            />
          </div>
        </div>
        <div>
          {fetching ? (
            <div className={styles.ripple_loading}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          ) : (
            this.renderCollaboratorFinancial()
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.capacityPlaning.collaboratorFinancial.fetching,
  collaboratorFinancialData: state.capacityPlaning.collaboratorFinancial.data,
  collaboratorFinancialColumns:
    state.capacityPlaning.collaboratorFinancial.columns
});

export default connect(mapStateToProps)(CapacityPlaningCollaboratorFinancials);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningCollaboratorFinancials.js